import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import ProtectedLink from '../ProtectedLink';
import '../../styles/home/IntelligenceSection.css';

const features = [
  { emoji: '🔍', title: 'Smart Search', desc: 'Intelligent catalog search by SKU, category, brand, or availability.' },
  { emoji: '🎙️', title: 'Voice Ordering', desc: 'Place reorders and browse catalog using natural voice commands.' },
  { emoji: '📊', title: 'Delivery Insights', desc: 'Historical delivery analytics, route performance, and volume reporting.' },
  { emoji: '💡', title: 'Smart Alerts', desc: 'Proactive notifications for stock levels, ETA changes, and anomalies.' },
];

const feedItems = [
  { emoji: '🔍', text: 'Search products, SKUs, or ask anything...', badge: 'Voice', badgeColor: '#3B6EF6', badgeBg: '#3B6EF6', isSearch: true },
  { emoji: '🍺', text: 'Beverages — reorder suggested', badge: '↓18%', badgeColor: '#EF4444', badgeBg: 'transparent' },
  { emoji: '🚚', text: 'Route 7 ETA updated', badge: '2:30 PM', badgeColor: '#FFFFFF', badgeBg: 'transparent' },
  { emoji: '📈', text: 'Weekly volume — above target', badge: '+24%', badgeColor: '#10B981', badgeBg: 'transparent' },
  { emoji: '🎙️', text: '"Reorder Batch B — 50 cases"', badge: 'Confirmed', badgeColor: '#10B981', badgeBg: 'rgba(16,185,129,0.12)', isBadgePill: true },
  { emoji: '🔔', text: '3 orders confirmed for tomorrow\'s delivery window', badge: 'NEW', badgeColor: '#3B6EF6', badgeBg: 'rgba(59,110,246,0.12)', isBadgePill: true, isHighlight: true },
];

const IntelligenceSection: React.FC = () => {
  return (
    <section className="intelligence">
      <div className="intelligence__container">
        {/* ── Left Content ── */}
        <div className="intelligence__content">
          <span className="intelligence__tag">VIN PULSE OS</span>
          <h2 className="intelligence__heading">
            Intelligence Behind Every Order
          </h2>
          <p className="intelligence__subtitle">
            VIN Pulse OS is our proprietary operating layer — powering smart
            search, voice ordering, real-time delivery insights, and proactive
            alerts all within your partner portal.
          </p>

          {/* 2x2 Feature cards */}
          <div className="intelligence__features">
            {features.map((f) => (
              <div key={f.title} className="intelligence__feature">
                <span className="intelligence__feature-emoji">{f.emoji}</span>
                <h3 className="intelligence__feature-title">{f.title}</h3>
                <p className="intelligence__feature-desc">{f.desc}</p>
              </div>
            ))}
          </div>

          <ProtectedLink to="/products" className="intelligence__cta">
            Explore VIN Pulse OS <MdArrowForward />
          </ProtectedLink>
        </div>

        {/* ── Right: Live Feed Panel ── */}
        <div className="intelligence__visual">
          <div className="intelligence__panel">
            {/* Panel header */}
            <div className="intelligence__panel-header">
              <span className="intelligence__panel-logo">
                VIN <span className="intelligence__panel-logo--accent">Pulse</span> OS
              </span>
              <span className="intelligence__panel-live">
                <span className="intelligence__panel-live-dot" />
                LIVE
              </span>
            </div>

            {/* Feed items */}
            <div className="intelligence__panel-feed">
              {feedItems.map((item, i) => (
                <div
                  key={i}
                  className={`intelligence__feed-item ${item.isHighlight ? 'intelligence__feed-item--highlight' : ''} ${item.isSearch ? 'intelligence__feed-item--search' : ''}`}
                >
                  <span className="intelligence__feed-emoji">{item.emoji}</span>
                  <span className="intelligence__feed-text">{item.text}</span>
                  {item.isBadgePill ? (
                    <span
                      className="intelligence__feed-badge intelligence__feed-badge--pill"
                      style={{ color: item.badgeColor, background: item.badgeBg }}
                    >
                      {item.badge}
                    </span>
                  ) : item.isSearch ? (
                    <span
                      className="intelligence__feed-badge intelligence__feed-badge--voice"
                      style={{ background: item.badgeBg }}
                    >
                      🎙️ {item.badge}
                    </span>
                  ) : (
                    <span
                      className="intelligence__feed-value"
                      style={{ color: item.badgeColor }}
                    >
                      {item.badge}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntelligenceSection;
